import { formatRoundedNumber } from '@/lib/formatUtils';
import { FormFieldV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface BottomBarProps {
  tongPSno: number;
  tongPSCo: number;
  ty_gia: number;
}

export function BottomBar({ tongPSno, tongPSCo, ty_gia }: BottomBarProps) {
  const isVND = ty_gia == 1;

  return (
    <div className='w-full border-t bg-white px-4 py-2 pb-6'>
      <div className='flex'>
        <div className='flex flex-col'>
          <div className='flex items-center gap-4'>
            <Label className='w-28 font-bold'>Tổng ps nợ</Label>
            <FormFieldV2 name='t_ps_no_nt' type='text' value={formatRoundedNumber(tongPSno)} />
            <FormFieldV2
              name='t_ps_no'
              className={isVND ? 'hidden' : ''}
              type='text'
              value={formatRoundedNumber(tongPSno * ty_gia)}
            />
          </div>
          <div className='flex items-center gap-4'>
            <Label className='w-28 font-bold'>Tổng ps có</Label>
            <FormFieldV2 name='t_ps_co_nt' type='text' value={formatRoundedNumber(tongPSCo)} />
            <FormFieldV2
              name='t_ps_co'
              className={isVND ? 'hidden' : ''}
              type='text'
              value={formatRoundedNumber(tongPSCo * ty_gia)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottomBar;
